import React, { useMemo } from "react";
import {
  ArrowIcon,
  colors,
  Label,
  Row,
  Select,
  Typography,
} from "@commonsku/styles";

import {
  OptionProps,
  SingleValue,
  SingleValueProps,
  components,
} from "react-select";
import {
  PresentationStyleOption,
  PresentationStyle,
  PresentationStyleType,
} from "./types";
import { SelectOption } from "./SelectOption";

const optionContainerStyles: React.CSSProperties = {
  display: "flex",
  width: "100%",
  maxWidth: "320px",
  alignItems: "center",
};

const optionStyles: React.CSSProperties = {
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  overflow: "hidden",
};

const TemplateOptionComponent = () => (
  <div style={optionContainerStyles}>
    <div style={optionStyles}>Templates</div>
    <div
      style={{
        display: "flex",
        marginLeft: "8px",
      }}
    >
      <ArrowIcon direction="left" color={colors.secondary1[60]} />
      <Typography.Text
        style={{
          color: colors.secondary1[60],
          margin: 0,
          padding: 0,
          lineHeight: "28px",
        }}
      >
        New and awesome!
      </Typography.Text>
    </div>
  </div>
);

const LabelComponent = (props: SingleValueProps<PresentationStyleOption>) => {
  const { data } = props;
  let OptionComponent: JSX.Element;

  switch (data.value) {
    case PresentationStyle.LIST:
    case PresentationStyle.GALLERY:
    case PresentationStyle.TILE:
    case PresentationStyle.SMART:
      OptionComponent = <data.Component />;
      break;
    case PresentationStyle.TEMPLATE:
      OptionComponent = <TemplateOptionComponent />;
      break;
  }

  return (
    <components.SingleValue {...props}>
      {OptionComponent}
    </components.SingleValue>
  );
};

const PresentationStyleOptionComponent = (
  props: OptionProps<PresentationStyleOption>
) => {
  let optionComponent: JSX.Element;
  const { data } = props;
  switch (data.value) {
    case PresentationStyle.TEMPLATE:
      optionComponent = <TemplateOptionComponent />;
      break;
    default:
      optionComponent = <data.Component />;
      break;
  }

  return <SelectOption {...props} children={optionComponent} />;
};

const SelectOptionComponent = (label: string) => <Row>{label}</Row>;

const options: PresentationStyleOption[] = [
  {
    value: PresentationStyle.TILE,
    Component: () => SelectOptionComponent("Tiles (legacy)"),
  },
  {
    value: PresentationStyle.LIST,
    Component: () => SelectOptionComponent("List (legacy)"),
  },
  {
    value: PresentationStyle.GALLERY,
    Component: () => SelectOptionComponent("Gallery (legacy)"),
  },
  {
    value: PresentationStyle.SMART,
    Component: () => SelectOptionComponent("Smart Gallery (legacy)"),
  },
  {
    value: PresentationStyle.TEMPLATE,
    Component: TemplateOptionComponent,
  },
];

export interface PresentationStyleSelectProps {
  currentValue: PresentationStyleType;
  onUpdateField: (field: string, value: PresentationStyleType) => void;
}

const PresentationStyleSelect = React.memo(
  ({ onUpdateField, currentValue }: PresentationStyleSelectProps) => {

    const value = useMemo(() => {
      return options.find((option) => option.value === currentValue);
    }, [currentValue]);

    const handleChange = (option: SingleValue<PresentationStyleOption>) => {
      if (!option) return;
      onUpdateField("view_type", option.value);
    };

    return (
      <>
        <Label>Presentation Style</Label>
        <Select
          value={value}
          containerStyles={{ width: "100%" }}
          options={options}
          onChange={handleChange}
          inPopup
          components={{
            Option: PresentationStyleOptionComponent,
            SingleValue: LabelComponent,
          }}
          isMulti={false}
          singleValueStyles={{
            display: "flex",
            alignItems: "center",
          }}
        />
      </>
    );
  }
);

export default PresentationStyleSelect;
